import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDetailDynamicBlock extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateFromVariant);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateFromVariant);
  }

  updateFromVariant = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector(this.tagName.toLowerCase());
    if (!newBlock) return;

    morph(this, newBlock, { childrenOnly: true });
  };
}

if (!customElements.get('product-price-stack')) {
  customElements.define('product-price-stack', ProductDetailDynamicBlock);
}

if (!customElements.get('stock-status')) {
  customElements.define('stock-status', ProductDetailDynamicBlock);
}

if (!customElements.get('specification-table')) {
  customElements.define('specification-table', ProductDetailDynamicBlock);
}
